import axiosClient from "src/features/axios/client";
import { EmployeeRegistrationForm } from "src/features/employees/components/EmployeeRegistrationFormDialog";
import {
  LoginFormSchemaType,
  RequestPasswordResetSchemaType,
  RequestUsernameSchemaType,
  ResetPasswordSchemaType,
} from "../types/auth.types";

class AuthService {
  async getInviteData(token: string) {
    return await axiosClient
      .get(`/api/invites/${token}/`)
      .then((res) => res.data);
  }

  async login(data: LoginFormSchemaType) {
    return await axiosClient
      .post("/api/token-login/", data)
      .then((res) => res.data);
  }

  async logout() {
    return await axiosClient.post("/api/token-logout/").then((res) => res.data);
  }

  async registerEmployee(
    data: EmployeeRegistrationForm & { email_code?: string }
  ) {
    return await axiosClient
      .post("/api/employee/register/", data)
      .then((res) => res.data);
  }

  async requestPasswordReset(data: RequestPasswordResetSchemaType) {
    return await axiosClient
      .post("/api/password-reset-request/", data)
      .then((res) => res.data);
  }

  async requestUsername(data: RequestUsernameSchemaType) {
    return await axiosClient
      .post("/api/forgot-username/", data)
      .then((res) => res.data);
  }

  async resetPassword(data: ResetPasswordSchemaType) {
    return await axiosClient
      .post("/api/password-reset/", data)
      .then((res) => res.data);
  }

  /** The HttpOnly refresh cookie goes with the request; ``refreshToken`` is a body fallback. */
  async refreshToken(refreshToken?: string | null) {
    return await axiosClient
      .post("/api/token-refresh/", refreshToken ? { refresh: refreshToken } : {})
      .then((res) => res.data);
  }
}

const authService = new AuthService();

export default authService;
